import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { Addendum } from "types";

type UpdateAddendumPayload = {
  addendumId: string;
  text: string;
};

function useUpdateAddendum() {
  return useAxiosMutation(
    ["updateAddendum"],
    ({ addendumId, text }: UpdateAddendumPayload) =>
      axiosChartInstance.put<Addendum>(`v1/addendum/${addendumId}`, { text })
  );
}

export type { UpdateAddendumPayload };
export { useUpdateAddendum };
